import Dexie, { Table } from "dexie";
import { AccessStatusEnum } from "requests/generated";
import { StoredAnestheticProtocol } from "../duck/types";

interface DVMDb extends Dexie {
  user: Table;
  procedures: Table;
  users: Table;
  breeds: Table;
  medications: Table;
  protocols: Table<StoredAnestheticProtocol>;
  pinLogins: Table<{ status: AccessStatusEnum; time: string }>;
  authorizations: Table;
  disclaimerProcedures: Table;
  disclaimerText: Table<{ key: string; value: string }>;
}

const db = new Dexie("dvm") as DVMDb;

db.version(8).stores({
  user: "&id, data, pin",
  procedures: "&_id,name",
  users: "&_id,firstName,lastName,userRole",
  breeds: "&_id,name,species",
  medications: "&_id,name,concentration",
  protocols: "&_id,name",
  pinLogins: "&time,status",
  disclaimerProcedures: "&_id,title,description",
  authorizations: "&_id,condition",
  disclaimerText: "&key"
});

export default db;
